import React, { useEffect, useRef } from "react";
import "./PopupOne.css";
import { Modal } from "bootstrap";
import keyImg from "../../images/key11.svg";
import lockImg from "../../images/lock11.svg";
import { useNavigate } from "react-router-dom";

function PopupOne({SubId,handleSub,handleMile,HandlePayment,SubPayment,PopupContent}) {

  const modalRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (modalRef.current) {
      const modalInstance = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });

      modalInstance.show();

      return () => {
        modalInstance.hide();
        // Clean up the backdrop manually if it gets stuck
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();
      };
    }
  }, []);
  return (
    <div className="custom-modal-oneDiv">
      <div
        className="modal fade custom-modal-oneDiv-modal"
        ref={modalRef}
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog custom-modal-oneDiv-dialog">
          <div className="modal-content">
            <div className="custom-imgLogo">
              <img src={keyImg} alt="" />
            </div>

            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {PopupContent?.dilemma_popup_title}
              </h5>
              <div dangerouslySetInnerHTML={{ __html: PopupContent?.dilemma_popup_content}}/>
              <div className="custopm-pop-group-btn">
                <button

                   onClick={() =>{ HandlePayment(SubPayment)}
                        
                  } 
                >
                  <span>
                    <img src={lockImg} alt="" />
                  </span>
                  <span>{PopupContent?.dilemma_unlock_button_label}</span>
                </button>
                
                <button 

                  onClick={() =>{ handleSub(SubId)
                       handleMile(true);
                  }
                    
                } 
  
                >

                  {PopupContent?.dilemma_view_plan_label}

                </button>

                <a 
                  onClick={(e) => {
                      e.preventDefault();
                      navigate("/dashboard");
                    }}
                  >
                  
                   {PopupContent?.dilemma_maybe_label}</a>
              </div>

              <a
                type="button"
                className="btn-close cus-btn-close"
                // data-bs-dismiss="modal"
                // aria-label="Close"

                // onClick={() => {
                //                 handleMile(true);
                //             }}

                 onClick={(e) => {
                      e.preventDefault();
                      navigate("/dashboard");
                    }}
              ></a>
      
            </div>
            <div className="modal-body">

              <div className="custom-popup-content"  dangerouslySetInnerHTML={{ __html: PopupContent?.dilemma_popup_bottom_content}}/>
               
            </div>
          </div>


        </div>
      </div>
    </div>
  );
}

export default PopupOne;
